"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_final_form_1 = require("react-final-form");
var ButtonPrimary_1 = __importDefault(require("atomicComponents/atoms/Buttons/ButtonPrimary"));
var Modal_1 = __importDefault(require("atomicComponents/organisms/Modal"));
var ModalContent_1 = __importDefault(require("atomicComponents/organisms/Modal/ModalContent"));
var ModalFooter_1 = __importDefault(require("atomicComponents/organisms/Modal/ModalFooter"));
var ModalHeader_1 = __importDefault(require("atomicComponents/organisms/Modal/ModalHeader"));
var TextField_1 = __importDefault(require("shared/components/Form/TextField"));
var Heading_1 = __importDefault(require("shared/components/Heading"));
var validators_1 = require("utils/form/validators");
var hooks_1 = require("./hooks");
var CreateCustomerModal = function (props) {
    var createCompany = (0, hooks_1.useCreateCompany)();
    return ((0, jsx_runtime_1.jsxs)(Modal_1.default, __assign({}, props, { label: "Create customer account" }, { children: [(0, jsx_runtime_1.jsx)(ModalHeader_1.default, { children: (0, jsx_runtime_1.jsx)(Heading_1.default, __assign({ level: 3 }, { children: "Create customer account" })) }), (0, jsx_runtime_1.jsx)(react_final_form_1.Form, __assign({ onSubmit: function (values) { return createCompany(values).then(props.onClose); }, validate: function (fV) { return (0, validators_1.requiredFields)(['name'])(fV); } }, { children: function (_a) {
                    var handleSubmit = _a.handleSubmit, submitting = _a.submitting;
                    return ((0, jsx_runtime_1.jsxs)("form", __assign({ onSubmit: handleSubmit }, { children: [(0, jsx_runtime_1.jsx)(ModalContent_1.default, { children: (0, jsx_runtime_1.jsx)(react_final_form_1.Field, { name: "name", color: "secondary", disabled: submitting, component: TextField_1.default, placeholder: "Company name", title: "Company name" }) }), (0, jsx_runtime_1.jsx)(ModalFooter_1.default, { children: (0, jsx_runtime_1.jsx)(ButtonPrimary_1.default, __assign({ type: "submit", disabled: submitting }, { children: "Create and onboard customer" })) })] })));
                } }))] })));
};
exports.default = CreateCustomerModal;
